(function () {
    'use strict';

    angular
        .module('generalReports')
        .config(GeneralReportsRoute);

    GeneralReportsRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function GeneralReportsRoute($stateProvider) {
        $stateProvider
            .state('root.generalReports', {
                abstract: true,
                url: '/generalreports',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                }
            })
            .state ('root.generalReports.clientHistory', {
                url: '/clienthistory',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/general-reports/client-history/reportFilter.html',
                        controller: 'GeneralReportsClientHistoryController',
                        controllerAs: 'generalReportsClientHistoryController'
                    }
                }
            })
            .state ('root.generalReports.targets', {
                url: '/sales',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/general-reports/targets/reportFilter.html',
                        controller: 'TargetsController',
                        controllerAs: 'targets'
                    }
                }
            })
            .state ('root.generalReports.eventsPerformance', {
                url: '/eventsPerformance',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/general-reports/events-performance/eventsPerformance.html',
                        controller: 'EventsPerformanceController',
                        controllerAs: 'eventsPerformance'
                    }
                }
            })
            .state ('root.generalReports.sellerGoals', {
                url: '/seller-goals',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/general-reports/seller-goals/reportFilter.html',
                        controller: 'SellerGoalsController',
                        controllerAs: 'sellerGoals'
                    }
                }
            });
    }
})();